import { render, staticRenderFns } from "./IconDropdownNew.vue?vue&type=template&id=d274bc40"
import script from "./IconDropdownNew.vue?vue&type=script&lang=js"
export * from "./IconDropdownNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports